import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { StockService } from '../../../services/StockService';
import { GetStockListPagingAndFilterRequest, initialGetStockListPagingAndFilterRequest } from '../../../models/request/stock/GetStockListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetStockListPagingAndFilterResponse, GetStockListPagingAndFilterResponseData, GetStockListPagingAndFilterResponseItem, initialGetStockListPagingAndFilterResponseData } from '../../../models/response/stock/GetStockListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { DeleteStockResponse } from '../../../models/response/stock/DeleteStockResponse';
import StockListFilters from './Components/StockListFilters';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ExportStockListResponse } from '../../../models/response/stock/ExportStockListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import StatusBadge from '../../../components/StatusBadge';
import { CompanyService } from '../../../services/CompanyService';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const StockList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > Cihaz Stok Tanımları"
    const pageVersion = "3";
    const [data, setData] = useState<GetStockListPagingAndFilterResponseData>(initialGetStockListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetStockListPagingAndFilterRequest>(initialGetStockListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Cihaz No', name: 'deviceNo', order: 0, isVisible: true },
            { title: 'Cihaz Seri No', name: 'macNumber', order: 0, isVisible: true },
            { title: 'Cihaz Marka', name: 'parentDeviceBrandName', order: 0, isVisible: true },
            { title: 'Cihaz Model', name: 'deviceBrandName', order: 0, isVisible: true },
            { title: 'Cihaz IMEI', name: 'imei', order: 0, isVisible: true },
            { title: 'CCID', name: 'ccid', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'companyName', order: 0, isVisible: true },
            { title: 'Plaka', name: 'plate', order: 0, isVisible: true },
            { title: 'Son Konum', name: 'gpsDateTime', order: 0, isVisible: true },
            { title: 'Sim No', name: 'gsmStockName', order: 0, isVisible: true },
            { title: 'Envanter Durumu', name: 'inventoryStatusName', order: 0, isVisible: true },
            { title: 'Cihaz Durumu', name: 'deviceStatusName', order: 0, isVisible: true },
            { title: 'Kontak', name: 'ioStatus', order: 0, isVisible: true },
            { title: 'RFID', name: 'rfid', order: 0, isVisible: true },
            { title: 'Demo', name: 'isDemo', order: 0, isVisible: true },
            { title: 'Yazılım Version', name: 'softwareVersion', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteStock = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.stockId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteStockResponse = await StockService.deleteStock(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateStock = async (_id: string | undefined = undefined) => {
        navigate('/stock/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].stockId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetStockListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetStockListPagingAndFilterResponse = await StockService.getStockListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.stockId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportStockListResponse = await StockService.exportStockList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.stockId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Son konum, kontak ve RFID canlı cihaz
    // verisinden geldiği için (veritabanında karşılığı yok) ve oluşturan/güncelleyen
    // bilgisi listede yok.
    const sortableColumns = [
        'deviceNo', 'macNumber', 'parentDeviceBrandName', 'deviceBrandName',
        'imei', 'ccid', 'companyName', 'plate', 'gsmStockName',
        'inventoryStatusName', 'deviceStatusName', 'isDemo', 'softwareVersion'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (StockManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        // Son Konum, Kontak ve RFID canlı cihaz verisi: filtresiz.
        deviceNo: { type: 'text' },
        macNumber: { type: 'text' },
        // Marka, modelin üst kaydı; seçilen markanın tüm modellerindeki stoklar gelir.
        parentDeviceBrandName: { type: 'select', loadOptions: () => loadConstants('DEVICE_BRAND') },
        deviceBrandName: { type: 'select', loadOptions: () => loadConstants('DEVICE_BRAND_DETAIL') },
        imei: { type: 'text' },
        ccid: { type: 'text' },
        companyName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCompany: true }), 'companyId', x => x.name) },
        plate: { type: 'text' },
        gsmStockName: { type: 'text' },
        inventoryStatusName: { type: 'select', loadOptions: () => loadConstants('INVENTORY_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        deviceStatusName: { type: 'select', loadOptions: () => loadConstants('DEVICE_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        isDemo: YES_NO_FILTER,
        softwareVersion: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetStockListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "gpsDateTime") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}>{Helpers.isEmpty(item.gpsDateTime) ? <i style={{ fontSize: 18 }} className={`text-muted fa fa-question-circle`} /> : <>{item.gpsDateTime}</>}</td>
            )
        }
        else if (column == "ioStatus") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}><i style={{ fontSize: 18 }} className={`${Helpers.isEmpty(item.ioStatus) ? 'text-muted' : item.ioStatus ? 'text-success' : 'text-danger'} fa ${Helpers.isEmpty(item.ioStatus) ? 'fa-question-circle' : item.ioStatus ? 'fa-check-circle' : 'fa-times-circle'}`} /></td>
            )
        }
        else if (column == "rfid") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}><i style={{ fontSize: 18 }} className={`${Helpers.isEmpty(item.rfid) ? 'text-muted' : item.rfid ? 'text-success' : 'text-danger'} fa ${Helpers.isEmpty(item.rfid) ? 'fa-question-circle' : item.rfid ? 'fa-check-circle' : 'fa-times-circle'}`} /></td>
            )
        }
        else if (column == "isDemo") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}><i style={{ fontSize: 18 }} className={`${item.isDemo ? 'text-success' : 'text-danger'} fa ${item.isDemo ? 'fa-check-circle' : 'fa-times-circle'}`} /></td>
            )
        }
        else if (column == "inventoryStatusName" || column == "deviceStatusName") {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}><StatusBadge text={item2[column]} /></td>;
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.stockId)} onDoubleClick={!item.companyId ? undefined : () => updateStock(item.stockId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <StockListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteStock}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateStock}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.stockId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default StockList;